export const SHADOWS = {
  SHADOW_01: "0 0 8px 0 rgba(0,0,0,0.16)",
  SHADOW_02: "0 2px 8px 0 rgba(0,0,0,0.16)",
  SHADOW_03: "0 4px 8px 0 rgba(0,0,0,0.16)",
  SHADOW_04: "0 8px 16px 0 rgba(0,0,0,0.16)",
};
